import { render, staticRenderFns } from "./PopupSwitchWeek.vue?vue&type=template&id=3b95652b&scoped=true&"
import script from "./PopupSwitchWeek.vue?vue&type=script&lang=js&"
export * from "./PopupSwitchWeek.vue?vue&type=script&lang=js&"
import style0 from "./PopupSwitchWeek.vue?vue&type=style&index=0&id=3b95652b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95652b",
  null
  
)

export default component.exports